import { Navigate, useRoutes } from "react-router-dom"
import { FinishPage } from "../FinishPage"
import { TroubleReportPage } from "../TroubleReportPage"
import { TroublesConfirmPage } from "../TroublesConfirmPage"
import { PlacementIncompleteProvider } from "../providers/placementIncomplete"
import { useTranslation } from "@/hooks/useTranslation"

export const OperationReportRoutes = () => {
    const { t } = useTranslation()

    const translatedRoutes = [
        {
            path: `troubles`,
            element: <TroubleReportPage />
        },
        {
            path: `troubles/next`,
            element: <TroublesConfirmPage title={t("さらに報告しますか？")} />
        },
        {
            path: `finish`,
            element: <FinishPage />
        },
        {
            path: "ready-for-troubles",
            element: (
                <TroublesConfirmPage title={t("トラブルはありましたか？")} />
            )
        },
        {
            path: "*",
            element: <Navigate to={`troubles`} />
        }
    ]

    const element = useRoutes(translatedRoutes)

    return <PlacementIncompleteProvider>{element}</PlacementIncompleteProvider>
}
